import { ApiDatafanOAuth, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery } from "react-query";
import { UseQueryOptions } from "react-query/types/react/types";

const KEY = "datafan.oauth.app";

type Params = Parameters<typeof ApiDatafanOAuth.getApp>[0];
type Response = Await<ReturnType<typeof ApiDatafanOAuth.getApp>>;

export const useQueryDatafanOAuthApp = (
  params: Params,
  options?: Omit<
    UseQueryOptions<Response, FailureApi, Response>,
    "queryKey" | "queryFn" | "select"
  >,
) =>
  useQuery<Response, FailureApi, Response>(
    [KEY, params],
    () => ApiDatafanOAuth.getApp(params),
    options,
  );

useQueryDatafanOAuthApp.KEY = KEY;
